/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
import{o as e,t,u as n}from"vendor/lit";import{a as r,i,r as a,t as o}from"vendor/decorate";import{AddVehicleSource as s,MyGarageEvents as c,isMyGarageChangeViewEvent as l,shouldAutoExpandGarage as u}from"components-garage/events";import{isSearchPage as d}from"utils/routing";import{d as f,o as p}from"algolia/client";var m=class extends t{static{this.styles=n`:host {
  --text-color-og: 22 22 22;
  background-color: #f91b1b;
  justify-content: center;
  width: 100%;
  display: none;
  position: sticky;
  top: 0;
}

@media (min-width: 769px) {
  .myGarage__drawer__content:after {
    content: "";
    pointer-events: none;
    border: 8px solid #f000;
    border-bottom-color: red;
    width: 0;
    height: 0;
    margin-left: -8px;
    position: absolute;
    top: -27px;
    right: 65px;
  }
}

@media (min-width: 1024px) {
  .myGarage__drawer__content:after {
    top: -32px;
  }
}

.myGarage {
  justify-content: center;
  width: 100%;
  display: flex;
}

.myGarage__drawer__backdrop {
  content: "";
  height: calc(100vh - var(--header-height) + 7vh);
  z-index: -1;
  background-color: #00000080;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.myGarage > button {
  font-size: calc(var(--body-font-size) * .1rem);
  font-family: var(--navigation-font-family);
  font-style: var(--navigation-font-style);
  font-weight: var(--navigation-font-weight);
  cursor: pointer;
  background-color: #0000;
  border: none;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;
  display: inline-flex;
}

.myGarage__drawer {
  color: #fff;
  box-sizing: border-box;
  padding: calc(2 * var(--space-unit));
  background-color: red;
  width: 100%;
  transition: top .2s ease-in-out;
  display: block;
}

.myGarage__drawer[data-is-open="true"] {
  box-shadow: 0 0 16px #00000026;
}

@media (min-width: 1024px) {
  .myGarage__drawer {
    padding-block: calc(3 * var(--space-unit));
  }
}

@media (max-width: 768px) {
  .myGarage__drawer {
    padding: calc(2 * var(--space-unit)) 0;
  }
}

.myGarage__drawer *, .myGarage__drawer :before, .myGarage__drawer :after {
  box-sizing: border-box;
}

.myGarage:hover .myGarage__drawer {
  display: block;
}

.myGarage__drawer__content {
  max-width: calc(var(--page-width, 1320px) + var(--gutter) * 2);
  padding: 0 var(--gutter);
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  margin: 0 auto;
  display: flex;
  position: relative;
}
`}constructor(){super(),this._pendingSource=``,this._changeViewEventHandler=e=>{l(e)&&(this._pendingSource=e.detail.source??``,window.setTimeout(()=>{this.activeView=e.detail.view},0))},this._canCloseMyGarage=()=>!d()||p()!==null||u(),this._handleKlaviyoFormEvents=e=>{switch(e.detail.type){case`open`:case`viewedStep`:case`embedOpen`:document.removeEventListener(`click`,this._autoCloseHandler);break;default:window.setTimeout(()=>{document.addEventListener(`click`,this._autoCloseHandler)},750)}},this._autoCloseHandler=e=>{this.activeView!==`initial`&&this.activeView!==`addVehicle`&&!document.body.getAttribute(`data-popover-open`)&&!this.contains(e.target)&&this._canCloseMyGarage()&&!document.querySelector(`kanter-garage-add-vehicle`)?.contains(e.target)&&(this.activeView=p()?`activeVehicle`:`initial`)},this._showAddVehicle=()=>u()&&d()&&!p(),this.activeView=p()?`activeVehicle`:this._showAddVehicle()?f().length===0?`addVehicle`:`garage`:`initial`,this._getActiveView=t=>{switch(t){case`addVehicle`:case`editVehicle`:return e`<kanter-garage-add-vehicle
          mode=${t===`editVehicle`?`edit`:`add`}
          source=${this._pendingSource}
        ></kanter-garage-add-vehicle>`;case`activeVehicle`:return e`<kanter-garage-active></kanter-garage-active>`;case`garage`:return e`<kanter-garage-filled></kanter-garage-filled>`;default:return e`<kanter-garage-empty></kanter-garage-empty>`}},this.activeView===`addVehicle`&&(this._pendingSource=s.autoExpand),window.addEventListener(c.changeView,this._changeViewEventHandler),document.addEventListener(`click`,this._autoCloseHandler),window.addEventListener(`klaviyoForms`,this._handleKlaviyoFormEvents)}disconnectedCallback(){super.disconnectedCallback(),window.removeEventListener(c.changeView,this._changeViewEventHandler),document.removeEventListener(`click`,this._autoCloseHandler),window.removeEventListener(`klaviyoForms`,this._handleKlaviyoFormEvents)}render(){let t=this.activeView!==`initial`&&this.activeView!==`activeVehicle`;return e`<div class="myGarage">
      <div class="myGarage__drawer" data-is-open=${t}>
        <div class="myGarage__drawer__content">
          ${this._getActiveView(this.activeView)}
        </div>
        ${t?e`<div
              @click=${this._autoCloseHandler}
              class="myGarage__drawer__backdrop"
              tabindex="0"
            ></div>`:``}
      </div>
    </div>`}};o([a()],m.prototype,`_pendingSource`,void 0),o([i({type:String,state:!0})],m.prototype,`activeView`,void 0),m=o([r(`kanter-garage-toolbar`)],m);export{m as MyGarage};